<script setup>
import {couponConf} from "@/utils/config";
import {computed, defineProps, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import store from "@/store";
import axiosApi from "@/utils/axiosApi";
import LoginComponents from "@/components/login/LoginComponents.vue";
import XmLogin from "@/components/login/xmLogin.vue";
import RealName from "@/components/login/RealName.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import {ElMessage} from "element-plus";
import router from "@/router";

const props = defineProps({
  type: {
    default: () => {
      return couponConf["meland-xmair"]
    }
  }
})
const account = computed(() => {
  return store.state.account
})
const order_from = computed(()=>store.state.orderFrom)
onMounted(async () => {
  store.commit("getCoupon")
  store.commit("getOrderFrom")
  await store.dispatch("getAccounts")
  getCoupon()
})
const coupon = ref({})
const route = useRoute()
const showLogin = ref(false)
const showProduct = ref(false)
const getCoupon = () => {
  showLogin.value = false
  new axiosApi({
    encode: 'site',
    method: "coupon/cat_coupon_detail",
    body: {
      cid: route.params.id
    }
  }).send(res => {
    if (res.message.code === "000") {
      res.data.detail = res.data.detail.filter(v => v.key.length && v.value.length)
      coupon.value = res.data
      let details = {}
      coupon.value.detail.forEach(v => {
        details[v.key] = v.value
      })
      coupon.value.detail = details
      console.log(coupon)
      document.title = coupon.value.name
    }
  })
}
const minPrices = computed(() => {
  if (Object.keys(coupon.value).length && coupon.value.score_data[props.type.login]) {
    return parseFloat(coupon.value.score_data[props.type.login].total)
  }
  return 0;
})
const number = ref(1)
const totalPrice = computed(() => {
  return minPrices.value * number.value
})
const maxNumber = computed(() => {
  let number = 1;
  if (Object.keys(account.value).length) {
    number = Math.floor(parseFloat(account.value.balance_miles) / minPrices.value);
  }

  return number
})
const loginCallback = () => {
  showLogin.value = false
  if (Object.keys(account.value).length && minPrices.value <= parseInt(account.value.balance_miles)) {
    showProduct.value = true
  }
}
const mobile = ref("")
const sendSms = ref(false)
const realname = ref(false)
const href = window.location.href
const loading = ref(false)
const payment = () => {
  if (!/^1[2-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("请输入收货手机号");
  }
  if (!sendSms.value && props.type.login !== 'xm_air') {
    sendSms.value = true
    return
  }

  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: account.value.access_token,
    user_id: account.value.user_id
  } : {cust_id: account.value.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: coupon.value.id,
      uid: account.value.uid,
      pay_type: props.type.login,
      pay_params,
      number: number.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    },
    score_type: props.type.login
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (props.type.login !== 'xm_air')
      router.replace({name: 'home', query: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <!--  {{ coupon }}-->
  <el-scrollbar class="page-pid page-detail" :style="props.type.style" v-if="Object.keys(coupon).length">
    <el-image :src="coupon?.images"/>
    <div class="coupon-content">
      <div class="coupon-title">
        <h3 class="title-h">MELAND {{ coupon?.name }}</h3>
        <span class="coupon-jingle">
          {{ coupon?.detail?.jingle }}
        </span>
      </div>
      <div class="coupon-info">
        <div class="coupon-info-its">
          <h4 class="title-h">套餐内容</h4>
          <el-text type="info">{{ coupon?.detail?.ticket }}</el-text>
        </div>
        <div class="coupon-info-its">
          <h4 class="title-h">有效期限</h4>
          <el-text type="info">自激活之日起{{ coupon?.term }}日内有效</el-text>
        </div>
      </div>
      <div class="coupon-info">
        <h3 class="title-h">购买须知</h3>
        <div class="coupon-info-values">
          <b class="coupon-info-label">使用时段</b>
          <el-text type="info" class="coupon-info-vals">{{ coupon?.detail?.date }}</el-text>
        </div>
        <div class="coupon-info-values">
          <b class="coupon-info-label">使用人数</b>
          <el-text type="info" class="coupon-info-vals">{{ coupon?.detail?.parms }}</el-text>
        </div>
        <div class="coupon-info-values">
          <b class="coupon-info-label">使用限制</b>
          <el-text type="info" class="coupon-info-vals">{{ coupon?.detail?.rules }}</el-text>
        </div>
      </div>
      <div class="coupon-info">
        <h3 class="title-h">详情介绍</h3>
        <div v-html="coupon?.remark" class="coupon-conts"></div>
      </div>
    </div>
  </el-scrollbar>
  <el-empty v-else/>
  <div class="footer" v-if="Object.keys(coupon).length">
    <div class="footer-price">
      <el-text :type="props.type?.login==='xm_air'?'primary':'danger'" class="footer-money">
        {{ (minPrices) }}
      </el-text>
      <el-text>{{ props.type?.login === 'xm_air' ? '积分' : '里程' }}</el-text>
    </div>
    <el-button round :type="props.type?.login === 'xm_air'?'primary':'danger'" v-if="Object.keys(account).length < 1"
               @click="showLogin=true">
      立即兑换
    </el-button>
    <el-button :type=" props.type.login === 'xm_air'?'primary':'danger'" round
               v-else-if="parseFloat(account.balance_miles) >= minPrices " @click="showProduct=true" :loading="loading">
      立即兑换
    </el-button>
    <el-button v-else type="info" round disabled>
      {{ props.type?.login === 'xm_air' ? '积分' : '里程' }}不足
    </el-button>
  </div>
  <login-components v-if="showLogin && type.login === 'scal'" :show-login="showLogin" @login="loginCallback"/>
  <xm-login :show-login="showLogin" :account="account" v-if="showLogin && type.login === 'xm_air'"
            @login="loginCallback"/>
  <el-drawer v-model="showProduct" direction="btt" class="product-drawer" size="540" :show-close="false"
             :style="props.type.style">
    <template #header>
      <div class="product-title">
        <div class="product-logo" style="padding: 25px 10px">
          <el-image :src="type.miniLogo"/>
        </div>
        <div class="product-title-items">
          <h4 class="title-h">MELAND {{ coupon.name }}</h4>
          <div class="product-prices">
            <!--            <el-text type="info">兑换</el-text>-->
            <el-text :type="props.type?.login==='xm_air'?'primary':'danger'" class="product-prices-values">
              {{ minPrices }}
            </el-text>
            <el-text>{{ props.type?.login === 'xm_air' ? '积分' : '里程' }}</el-text>
          </div>
        </div>
      </div>
    </template>
    <el-card class="product-card">
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">收货手机号</h4>
        </div>
        <div class="product-card-item-values">
          <el-input placeholder="请输入收货手机号" v-model="mobile"/>
        </div>
      </div>
    </el-card>
    <el-card class="product-card">
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">兑换数量</h4>
        </div>
        <div class="product-card-item-values">
          <el-input-number v-model="number" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card class="product-card">
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">可用{{ props.type.login === 'xm_air' ? '积分' : '里程' }}</h4>
        </div>
        <div class="product-card-item-values">
          {{ account.balance_miles }}
        </div>
      </div>
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">支付{{ props.type.login === 'xm_air' ? '积分' : '里程' }}</h4>
        </div>
        <div class="product-card-item-values">
          {{ totalPrice }}
        </div>
      </div>
    </el-card>
    <div class="product-pay-btn">
      <el-button :type="props.type.login === 'xm_air'?'primary':'danger'" round size="large" @click="payment" :loading="loading"
                 :disabled="Object.keys(account).length < 1 || account.balance_miles < totalPrice">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname" :href="href"/>
</template>

<style scoped lang="less">
.page-detail {
  height: calc(100vh - 64px);
  background: #ffffff;
  box-sizing: border-box;

  .coupon-content {
    padding: 15px;
    box-sizing: border-box;

    .coupon-title {
      line-height: 1.6;
      padding-bottom: 15px;
      border-bottom: 1px dashed;

      .coupon-jingle {
        color: var(--theme-text-color);
        font-size: .65rem;
        border: 1px solid var(--theme-text-color);
        padding: 5px;
        border-radius: 5px;
        display: inline-block;
        margin-top: 10px;
        text-align: justify;
      }
    }

    .coupon-info {
      margin-top: 15px;
      padding-bottom: 15px;
      line-height: 1.65;

      & + .coupon-info {
        border-top: 1px dashed;
        padding-top: 15px;
      }

      .coupon-info-its + .coupon-info-its {
        margin-top: 10px;
      }

      .coupon-info-values {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;

        .coupon-info-label {
          width: 5em;
          flex-basis: 5em;
          margin-right: 10px;
        }

        .coupon-info-vals {
          width: calc(100% - 5em - 10px);
          flex-basis: calc(100% - 5em - 10px);
          text-align: right;
        }
      }

      .coupon-conts {
        //line-height: 1.75;
        font-size: .9rem;
        text-align: justify;
        margin: 10px auto;
        /deep/ ol,ul{
          box-sizing: border-box;
          padding-left: 15px;
          margin-bottom: 28px;
          text-align: justify;
        }
        /deep/ p{
          position: relative;

          &+p{
            margin-top: 10px;
          }
          img{
            width: 100%;
            margin-top: -18px;
          }
        }
      }
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 15px;
  align-items: center;
  box-shadow: var(--el-box-shadow);
  height: 64px;

  .footer-price {
    margin-right: 10px;

    .footer-money {
      font-size: 1.35rem;
    }
  }
}

.title-h {
  font-weight: normal;
}
</style>
